import React from "react";
import './Body24.css';
import {Link} from "react-router-dom"
import picture369 from './source/picture369.png'
import picture368 from './source/picture368.png'
import picture367 from './source/picture367.png'
import picture366 from './source/picture366.png'
import picture365 from './source/picture365.png'





function Body24() {

  return (
    <div className="body24">
      <div className="body24-box1">
        <div className="body24-box2">
          <div className="body24-box3">Zlechov</div>
          <div className="body24-box5"><div className="body24-box4"></div></div>
          <div className="body24-box6">
          <img className="body24-box6-picture" src={picture369} alt="picture1"/>
          <img className="body24-box6-picture" src={picture367} alt="picture1"/>
          <img className="body24-box6-picture" src={picture366} alt="picture1"/>
          <img className="body24-box6-picture2" src={picture365} alt="picture1"/>
          <img className="body24-box6-picture2" src={picture368} alt="picture1"/>
          </div>
          <div className="body24-box8"><div className="body24-box7"><Link to="/PageProjekty">Zpět</Link></div></div>
        </div> 
      </div> 
    </div>
  );
}

export default Body24;
